<template>
  <div class="hj-home-tool" v-if="toolVisible">
    <!--    <div class="tool-item popover">
      <el-popover
        popper-class="communicate-popover"
        placement="left-start"
        width="76"
        trigger="hover"
        :close-delay="0"
      >
       <div>
          <div class="wangyeSerialNumber"  @click="handleSerialNumberCommand" >网页端投票</div>
          <img
            class="wx-img"
            src="../../assets/images/serialNumber-path.png"
          />
          <p>移动端扫码</p>
        </div>
        <div slot="reference" class="content">
          <wb-icon icon="toupiao"></wb-icon>
          <p>投票入口</p>
        </div>
      </el-popover>
    </div>-->
    <div
      class="tool-item btn serialNumberContent"
      @click="handleSerialNumberCommand"
    >
      <!--       <div class="red-dot">new</div>-->
      <div class="serialNumber-dot-icon">
        <wb-icon icon="toupiao1"></wb-icon>
      </div>
      <div class="serialNumber-dot-font">
        <wb-icon icon="toupiaotext"></wb-icon>
      </div>
      <div class="serialNumber-dot-font isphone"><p>短信验证</p></div>
    </div>

    <!--    <div class="tool-item popover serialNumberContent" >
     &lt;!&ndash; 左上角多个小红点提醒&ndash;&gt;
      <div class="red-dot">短信验证</div>
      <el-popover
        ref="serialNumberPopover"
        v-model="serialNumbervisible"
        popper-class="phone-popover"
        placement="left-start"
        width="120"
        trigger="hover"
        offset="-10"
        :close-delay="0"
      >
        <p @click="handleSerialNumberCommand">短信验证</p>
        <div slot="reference" class="content serialNumberPopover"   @click="handleSerialNumberCommand" >
          <wb-icon icon="toupiao1"></wb-icon>
          <p>短信验证</p>
        </div>
      </el-popover>
    </div>-->

    <div class="tool-item popover">
      <el-popover
        popper-class="communicate-popover"
        placement="left-start"
        width="76"
        trigger="hover"
        :close-delay="0"
      >
        <div>
          <img
            class="wx-img"
            src="@/assets/images/customer-service.png"
            alt=""
            @click="handleShowWeixin"
          />
          <p>微信扫一扫</p>
        </div>
        <div slot="reference" class="content">
          <wb-icon icon="telephone"></wb-icon>
          <p>客服小宏</p>
        </div>
      </el-popover>
    </div>

    <div class="tool-item popover">
      <el-popover
        popper-class="phone-popover"
        placement="left-start"
        width="120"
        trigger="hover"
        offset="-10"
        :close-delay="0"
      >
        <p @click="handleCall">400-0330-089</p>
        <div slot="reference" class="content">
          <wb-icon icon="consulting"></wb-icon>
          <p>电话咨询</p>
        </div>
      </el-popover>
    </div>

    <div class="tool-item btn" @click="handleReservationService">
      <wb-icon icon="appointment"></wb-icon>
      <p>预约演示</p>
    </div>

    <div class="tool-item popover" v-if="!IsPhone()">
      <el-popover
        popper-class="communicate-popover"
        placement="left-start"
        width="100"
        trigger="hover"
        :close-delay="0"
      >
        <div>
          <p><wb-icon icon="wx"></wb-icon>微信扫一扫</p>

          <vue-qr
            class="erweima"
            :text="currentUrl"
            :size="100"
            :margin="0"
          ></vue-qr>
        </div>
        <div slot="reference" class="content">
          <wb-icon icon="share"></wb-icon>
          <p>分享链接</p>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { infos } from './data/info.js'
import { getTypicalUsers } from '@/api/typicalUsers'
import VueQr from 'vue-qr'
import wx from 'weixin-js-sdk' // 引入wxjs
import { wxShare } from '@/api/user' // 分享的接口  传给后端一个地址(与域名一致)

export default {
  data() {
    return {
      toolVisible: false,
      serialNumbervisible: false,
      QRImgUrl: '',
      QRlink: '',
      currentUrl: window.location.href
    }
  },
  components: {
    VueQr
  },
  watch: {
    $route: {
      handler(n, o) {
        this.getShareInfo()
        this.toolVisible =
          n.name != 'fullPdf' && n.name != 'insidePlist' ? true : false

        this.currentUrl = window.location.href
      }
    }
  },
  mounted() {
    this.getShareInfo()
    this.$nextTick(() => {})
  },
  methods: {
    handleSerialNumberCommand() {
      window.open(window._cfg.API_BASE + '/mh/s', '_blank')
    },
    /**
     * 是否为平板（pad），平板与手机区分开，平板仍展示右侧工具
     */
    IsPad() {
      var ua = navigator.userAgent
      // iPad（含 iPad OS 13+ 的 Mac 型 UA）
      if (/ipad/i.test(ua)) return true
      if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        return true
      // 其他常见平板标识
      if (/tablet|playbook|silk/i.test(ua)) return true
      // Android 平板：部分机型 UA 带 Tablet 或不含 Mobile
      if (/android/i.test(ua) && !/mobile/i.test(ua)) return true
      return false
    },
    /**
     * 是否为手机（不含平板），仅手机不展示分享链接等
     */
    IsPhone() {
      var info = navigator.userAgent
      var isMobile = /mobile/i.test(info)

      // 是移动端且不是平板时视为手机
      return isMobile && !this.IsPad()
    },
    /**
     * 手机唤醒
     */
    handleCall() {
      let docWidth = document.body.clientWidth
      if (docWidth > 572) return

      window.location.href = 'tel://400-0330-089'
    },
    /**
     * 点击打开微信客服
     */
    handleShowWeixin() {
      let docWidth = document.body.clientWidth
      if (docWidth > 572) return

      window.location.href =
        'https://work.weixin.qq.com/kfid/kfc8c51a4435138b65f'
    },
    /**
     * 预约演示
     */
    handleReservationService() {
      this.$emit('showPre')
    },
    copyUrl() {
      var cInput = document.createElement('input')
      cInput.value = window.location.href
      document.body.appendChild(cInput)
      cInput.select() // 选取文本框内容

      document.execCommand('copy')

      this.$message({
        type: 'success',
        message: '复制成功'
      })
      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput)
    },
    // vue调用微信的自定义分享
    async getShareInfo() {
      wxShare({
        url: window.location.href
      }).then(async (res) => {
        if (res.success) {
          const config = res

          wx.config({
            debug: false,
            appId: config.appId, // appID 公众号的唯一标识
            timestamp: config.timestamp, // 生成签名的时间戳
            nonceStr: config.noncestr, //  生成签名的随机串
            signature: config.signature, // 生成的签名
            jsApiList: [
              'checkJsApi',
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          })
          let lArr = location.href.split('/')
          let objKey = decodeURIComponent(lArr[lArr.length - 1])

          if (objKey.includes('userStories')) {
            try {
              const response = await fetch(
                '/jx/images/platform/homepage/typicalUsers/typicalUsers.json?' +
                  new Date().getTime()
              )

              // 检查响应状态
              if (!response.ok) {
                throw new Error(`HTTP错误! 状态: ${response.status}`)
              }

              // 解析 JSON
              let caseList = await response.json()
              for (const key in caseList) {
                caseList[key] = caseList[key].filter((child) => {
                  return child.isCase == 1
                })
                caseList[key].forEach((casc) => {
                  infos['userStories?userName=' + casc.caseUrl] = {}
                  infos['userStories?userName=' + casc.caseUrl].title =
                    '宏景云平台-' + casc.name
                  infos['userStories?userName=' + casc.caseUrl].desc =
                    casc.userDesc
                })
              }
            } catch (err) {
              console.error('Fetch错误:', err)
            }
          }

          if (!infos[objKey]) {
            return
          }

          await wx.ready(() => {
            var shareData = {
              title: infos[objKey].title,
              desc: infos[objKey].desc,
              link: window.location.href,
              imgUrl: 'http://www.hjhrcloud.com/assets/images/logo_hjy.jpg' // 分享出去的图片地址
            }

            wx.onMenuShareTimeline(shareData)
            wx.onMenuShareAppMessage(shareData)
          })
          wx.error(function (res) {
            console.log(res)
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.communicate-popover {
  min-width: 126px !important;
  display: flex;
  justify-content: center;
  div {
    text-align: center;
    p {
      line-height: 26px;
      color: #666;
      font-size: 12px;
    }

    .copy-url {
      cursor: pointer;
    }
    .wx-img {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
<style lang="scss" scoped>
.red-dot {
  position: absolute;
  top: 0px;
  left: -18px;
  width: 42px;
  height: 20px;
  background-color: rgba(255, 0, 0, 0.96);
  border-radius: 4px;
  z-index: 1;
  // animation: blink 2s infinite;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 20px;
}
.serialNumber-dot-icon {
  animation: blink 2s infinite;
}
.serialNumber-dot-font {
  animation: blink 2s infinite;
  svg {
    display: none;
  }
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}

.wangyeSerialNumber {
  margin-bottom: 10px;
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 5px;
}
.wangyeSerialNumber:hover {
  color: #66b1ff;
  cursor: pointer;
}
.serialNumberContent {
  background: #2d84ff !important;
  color: #fff !important;
}

.hj-home-tool {
  z-index: 1300;
  position: fixed;
  right: 8px;
  bottom: 100px;
  .tool-item {
    &.btn {
      display: flex;
      cursor: pointer;
    }
    width: 70px;
    height: 70px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 1px solid #dedede;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #2d84ff;
    margin-top: 10px;

    ::v-deep .el-popover__reference-wrapper {
      .content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    svg {
      font-size: 32px;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 17px;
    }

    &:hover {
      background: #2d84ff;
      color: #fff;
    }
  }
}

/* 页面宽度小于572px
------------------------------- */
@media screen and (max-width: 572px) {
  .hj-home-tool {
    bottom: 200px;
  }
  .isphone {
    display: none !important;
  }
  .serialNumber-dot-icon {
    animation: icon-blink 2s infinite;
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .serialNumber-dot-font {
    animation: text-blink 2s infinite;
    display: flex;
    position: absolute;
    width: 32px;
    align-items: center;
    justify-content: center;
    text-align: center;
    p {
      display: flex;
      font-size: 12px !important;
      width: 2em;
      align-items: center;
      justify-content: center;
      text-align: center;
      word-break: break-all;
    }
    svg {
      display: unset;
      font-size: 30px !important;
    }
  }
  @keyframes icon-blink {
    0% {
      opacity: 1;
    }
    25% {
      opacity: 1;
    }
    26% {
      opacity: 0;
    }
    75% {
      opacity: 0;
    }
    76% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes text-blink {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0;
    }
    26% {
      opacity: 1;
    }
    75% {
      opacity: 1;
    }
    76% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
}

@media screen and (max-height: 500px) {
  .tool-item {
    width: 40px !important;
    height: 40px !important;
    svg {
      font-size: 20px !important;
    }
    p {
      display: none;
    }
  }
  .serialNumber-dot-font {
    svg {
      font-size: 30px !important;
    }
  }
}
</style>
